<template>
  <div class="singleerr">

    <div class="list_box"
         v-for="item in 3"
         :key="item">
      <div class="_row">
        <div class="strIcon">A</div>

        <div style="width: 400px;">
          <form_select v-model="ruleItem.action"
                       style="width: 400px;"
                       ref="form"
                       :options="[]"
                       placeholder="请选择事件"
                       class="select" />
        </div>

        <div style="display: inline-block;">

          <el-tooltip content="添加条件"
                      placement="top">
            <el-button type="text"
                       style="margin-left: 12px;"
                       icon="el-icon-zoom-in"></el-button> </el-tooltip>

          <el-tooltip content="删除"
                      placement="top">
            <el-button type="text"
                       @click="deleteRow()"
                       style="margin-left: 12px;"
                       icon="el-icon-delete"></el-button>
          </el-tooltip>
          <el-button type="primary"
                     size="mini">添加对象</el-button>
        </div>

      </div>
      <div class="_row_item">
        <div class="andOrIcon">
          AND
        </div>
        <div class="_row_item_box">
          <div class="_row_box"
               v-for="item in 3"
               :key="item">
            <div>
              <form_select v-model="ruleItem.action"
                           ref="form"
                           :options="[]"
                           placeholder="请选择属性"
                           class="select" />
            </div>
            <div style="width: 100px;">
              <form_select v-model="ruleItem.action"
                           ref="form"
                           :options="[]"
                           placeholder="请选择"
                           class="select" />
            </div>
            <div>
              <form_select v-model="ruleItem.action"
                           ref="form"
                           :options="[]"
                           placeholder="请选择属性值"
                           class="select" />
            </div>
            <div>
              <el-tooltip content="删除"
                          placement="top">
                <el-button type="text"
                           @click="deleteRow()"
                           style="margin-left: 12px;"
                           icon="el-icon-delete"></el-button>
              </el-tooltip>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import form_select from '../../userClustering/components_form/form_select.vue'
export default {
  components: {
    form_select
  },
  name: 'singleerr',
  data () {
    return {
      ruleItem: {}
    }
  }

}
</script>

<style lang="scss" scoped>
.singleerr {
  box-sizing: border-box;
  .list_box {
    margin-top: 20px;
    margin-bottom: 55px;
  }
  .select {
    display: inline-block;
    margin-right: 10px;
  }
  ._row {
    display: flex;
  }
  .strIcon {
    height: 38px;
    width: 40px;
    line-height: 38px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 5px 0 0 5px;
    background-color: #f4f6f8;
  }
  ._row_item {
    display: flex;
    align-items: center;
    border-left: 2px solid #ccc;
    border-radius: 0 0 0 10px;
    min-width: 1650px;
    margin-left: 80px;
    margin-top: -40px;
  }
  .andOrIcon {
    cursor: pointer;
    font-size: 16px;
    height: 24px;
    line-height: 24px;
    padding: 5px 10px;
    color: #5b93fc;
    border: 1px solid #ccc;
    border-radius: 12px;
    width: 50px;
    text-align: center;
    margin-left: -36px;
    background-color: #fff;
  }
  ._row_box {
    display: flex;
    height: 20px;
    margin-top: 30px;
  }
  ._row_item_box {
    box-sizing: border-box;
    padding-left: 10px;
  }
}
</style>